import React, {useEffect, useState} from 'react'
import Sidebar from '../../components/sidebar/Sidebar'
import {useDispatch, useSelector} from "react-redux";
import {Link, useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {getPenilaianGuru, resetTable, updateStatePenilaianGuru} from "../../features/penilaianGuruSlice";
import Profile from "../../components/Profile";

import TotalGuru from "../../assets/icons/Stat Icon-3.svg";
import Selesai from "../../assets/icons/selesai.svg";
import Belum from "../../assets/icons/belum.svg";
import RataRata from "../../assets/icons/rata-rata.svg";

import searchIcon from "../../assets/icons/search-icon.svg";
import LoadingTable from "../../components/LoadingTable";

import Tabbar from "../../components/Tabbar";
import {setCurrentKategori, setKategoriId} from "../../features/ketegoriSlice";
import {updateStateSiswa} from "../../features/siswaSlice";

import Download from "../../components/penilaianguru/Download";
import Table from "../../components/penilaianguru/Table";

const PRIMARY = '#3661EB'

const GREY = '#9B9B9B'
const BORDER = '#ECEEF2'

function PenilaianGuru() {


    const {
        isLoading,
        penilaianGuru,
        search

    } = useSelector(state => state.penilaianGuruSlice)



    let kategoriAll = [
        {id: 'all', kategori: 'Semua Guru'},
    ]



    // for change any state in monitorKelas Slic
    const dispatch = useDispatch()

    // Search function
    const location = useLocation()
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()



    useEffect(() => {
        dispatch(resetTable())
    }, []);


    useEffect(() => {
        dispatch(getPenilaianGuru({}))
    }, []);



    useEffect(() => {
        if (searchParams.get('paginate')) {
            dispatch(updateStatePenilaianGuru({name: 'currentPage', value: parseInt(searchParams.get('paginate'))}));
        }
    }, [location.pathname, navigate, searchParams]);

    useEffect(() => {
        if (searchParams.get('search')) {
            dispatch(updateStatePenilaianGuru({name: 'search', value: searchParams.get('search')}));
            dispatch(getPenilaianGuru({search: searchParams.get('search')}))
        }
    }, [])


    useEffect(() => {
        dispatch(updateStatePenilaianGuru({name: 'currentPage', value: 1}))
    }, [location.pathname.split('/').pop()]);



    function handleSearch() {
        dispatch(getPenilaianGuru({search}))
        dispatch(updateStatePenilaianGuru({name: 'currentPage', value: 1}))
        setSearchParams({
            'search': search
        })
    }

    function handleKeyDown(e) {
        if (e.key === 'Enter') {
            handleSearch();
        }
    }

    // search function this is the end

    return (
        <div className='wrapper-karyawan' >
            <Sidebar/>
            <div className='karyawan'>

                <div className='search-and-profile'>
                    <div className='wrap-search'>

                    </div>
                    <Profile/>
                </div>


                {!isLoading && (
                    <div style={{ display: 'flex', marginBottom: 32, justifyContent: 'space-between' }}>
                        {[
                            { label: 'Total Guru',     icon: TotalGuru,     value: penilaianGuru.headers.total_guru },
                            { label: 'Sudah Mengisi',  icon: Selesai,  value: penilaianGuru.headers.sudah_mengisi },
                            { label: 'Belum Mengisi',  icon: Belum,       value: penilaianGuru.headers.belum_mengisi },
                            { label: 'Rata Rata',      icon: RataRata,  value: penilaianGuru.headers.rata_rata },
                        ].map((stat, i) => (
                            <div key={i} style={{
                                background: '#fff', borderRadius: 14,
                                border: `1px solid ${BORDER}`,
                                width: 285, height: 88, overflow: 'hidden', flexShrink: 0,
                                display: 'flex', alignItems: 'stretch',
                            }}>

                                <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '0 16px' }}>
                                    <div style={{
                                        width: 44, height: 44, borderRadius: 10, background: '#EFF6FF',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                                    }}>
                                        <img src={stat.icon} width={24} alt="" />
                                    </div>
                                    <div>
                                        <p style={{ margin: 0, fontSize: 14, color: '#64748B', fontWeight: 500 }}>{stat.label}</p>
                                        <p style={{ margin: '4px 0 0', fontSize: 22, color: PRIMARY, fontWeight: 700 }}>{stat.value}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}



                <div className='title-btn'>
                    <h1>Penilaian Guru</h1>


                    <div style={{display: 'flex', justifyContent: 'end', alignItems: 'center', gap: '10px',width:500 }}>
                        {/*<Search*/}

                        {/*    placeholder='Cari guru / karyawan'*/}
                        {/*    value={search}*/}
                        {/*    setSearch={updateStatePenilaianGuru}*/}
                        {/*    stateName={'search'}*/}
                        {/*    onKeyDown={handleKeyDown}*/}
                        {/*    onChange={(e) => dispatch(updateStatePenilaianGuru({name: 'search', value: e.target.value}))}*/}
                        {/*/>*/}

                        <div style={{ display: 'flex', alignItems: 'center', gap: 12, background: '#fff', border: `1px solid ${BORDER}`, borderRadius: 10, padding: '0 16px', height: 48, width: 300 }}>
                            <span style={{ color: GREY, fontSize: 14 }}>🔍</span>
                            <input
                                type="text"
                                placeholder="Cari guru / karyawan"
                                value={search}
                                onKeyDown={handleKeyDown}
                                onChange={(e) => dispatch(updateStatePenilaianGuru({name: 'search', value: e.target.value}))}
                                style={{ border: 'none', outline: 'none', fontSize: 14, color: '#A6A6A6', flex: 1 }}
                            />
                        </div>
                        <button
                            className='btn-search'
                            style={{ gap: 12, background: '#fff', border: `1px solid ${BORDER}`, borderRadius: 10, padding: '0 16px', height: 48, width: 48}}
                            onClick={handleSearch}
                        >
                            <img src={searchIcon} alt=""/></button>
                    </div>
                </div>




                <div className='tabbar-filter'>
                    <Tabbar
                        options={[...kategoriAll]}
                        setKategoriId={setKategoriId}
                        setCurrentKategori={setCurrentKategori}
                        searchParams={''}
                        setKeterangan={updateStateSiswa}
                        path='/siswa'
                        sttic={true}

                    />

                    <div className='filter-angka'>

                        <Download />

                    </div>
                </div>


                {(isLoading) ?
                    <LoadingTable size={'large'}/>
                    : <Table/>
                }









            </div>
        </div>

    )
}

export default PenilaianGuru
